import cn from 'clsx';
import PropTypes from 'prop-types';

import {SEARCH_TYPE} from '@/src/app/constants/search';
import TextLocal from '@/src/textLocal/containers/TextLocal';
import {Separator, Text} from '@/src/ui';

import css from '../styles/SearchTabsNavigation.module.css';

const SearchTabsNavigation = ({onTabClick, activeSearchType}) => {
  const isAllTabActive = activeSearchType === SEARCH_TYPE.UNITED;
  const isCoursesTabActive = activeSearchType === SEARCH_TYPE.COURSES;
  const isUsersTabActive = activeSearchType === SEARCH_TYPE.USERS;
  const isClinicTabActive = activeSearchType === SEARCH_TYPE.CLINICS;
  const isVacanciesTabActive = activeSearchType === SEARCH_TYPE.VACANCIES;
  const isPostsTabActive = activeSearchType === SEARCH_TYPE.POSTS;

  return (
    <div
      className={cn(css.widget, {
        [css.multiWidget]: isAllTabActive,
      })}
    >
      <div className={css.linksList}>
        <div
          className={css.linkItem}
          onClick={isAllTabActive ? null : () => onTabClick(SEARCH_TYPE.UNITED)}
        >
          <Text
            color={isAllTabActive ? Text.COLOR.PRIMARY : Text.COLOR.GREY}
            fontSize={Text.FONT_SIZE.SIZE_18}
            fontWeight={
              isAllTabActive ? Text.FONT_WEIGHT.BOLD : Text.FONT_WEIGHT.NORMAL
            }
          >
            <TextLocal id={'search.all'} />
          </Text>
          {isAllTabActive && <div className={css.activeLinkBorder} />}
        </div>
        <div
          className={css.linkItem}
          onClick={
            isPostsTabActive ? null : () => onTabClick(SEARCH_TYPE.POSTS)
          }
        >
          <Text
            color={isPostsTabActive ? Text.COLOR.PRIMARY : Text.COLOR.GREY}
            fontSize={Text.FONT_SIZE.SIZE_18}
            fontWeight={
              isPostsTabActive ? Text.FONT_WEIGHT.BOLD : Text.FONT_WEIGHT.NORMAL
            }
          >
            <TextLocal id={'general.topics'} />
          </Text>
          {isPostsTabActive && <div className={css.activeLinkBorder} />}
        </div>
        <div
          className={css.linkItem}
          onClick={
            isCoursesTabActive ? null : () => onTabClick(SEARCH_TYPE.COURSES)
          }
        >
          <Text
            color={isCoursesTabActive ? Text.COLOR.PRIMARY : Text.COLOR.GREY}
            fontSize={Text.FONT_SIZE.SIZE_18}
            fontWeight={
              isCoursesTabActive
                ? Text.FONT_WEIGHT.BOLD
                : Text.FONT_WEIGHT.NORMAL
            }
          >
            <TextLocal id={'general.courses'} />
          </Text>
          {isCoursesTabActive && <div className={css.activeLinkBorder} />}
        </div>
        <div
          className={css.linkItem}
          onClick={
            isUsersTabActive ? null : () => onTabClick(SEARCH_TYPE.USERS)
          }
        >
          <Text
            color={isUsersTabActive ? Text.COLOR.PRIMARY : Text.COLOR.GREY}
            fontSize={Text.FONT_SIZE.SIZE_18}
            fontWeight={
              isUsersTabActive ? Text.FONT_WEIGHT.BOLD : Text.FONT_WEIGHT.NORMAL
            }
          >
            <TextLocal id={'search.users'} />
          </Text>
          {isUsersTabActive && <div className={css.activeLinkBorder} />}
        </div>

        <div
          className={css.linkItem}
          onClick={
            isClinicTabActive ? null : () => onTabClick(SEARCH_TYPE.CLINICS)
          }
        >
          <Text
            color={isClinicTabActive ? Text.COLOR.PRIMARY : Text.COLOR.GREY}
            fontSize={Text.FONT_SIZE.SIZE_18}
            fontWeight={
              isClinicTabActive
                ? Text.FONT_WEIGHT.BOLD
                : Text.FONT_WEIGHT.NORMAL
            }
          >
            <TextLocal id={'search.clinics'} />
          </Text>
          {isClinicTabActive && <div className={css.activeLinkBorder} />}
        </div>

        <div
          className={css.linkItem}
          onClick={
            isVacanciesTabActive
              ? null
              : () => onTabClick(SEARCH_TYPE.VACANCIES)
          }
        >
          <Text
            color={isVacanciesTabActive ? Text.COLOR.PRIMARY : Text.COLOR.GREY}
            fontSize={Text.FONT_SIZE.SIZE_18}
            fontWeight={
              isVacanciesTabActive
                ? Text.FONT_WEIGHT.BOLD
                : Text.FONT_WEIGHT.NORMAL
            }
          >
            <TextLocal id={'search.positions'} />
          </Text>
          {isVacanciesTabActive && <div className={css.activeLinkBorder} />}
        </div>
      </div>
      <Separator borderWeight={Separator.BORDER_WEIGHT.THIN} />
    </div>
  );
};

SearchTabsNavigation.propTypes = {
  onTabClick: PropTypes.func.isRequired,
  activeSearchType: PropTypes.string,
};

export default SearchTabsNavigation;
